export function dataUrlToBase64(dataUrl: string) {
  const s = String(dataUrl || '').trim()
  if (!s) return ''
  const i = s.indexOf('base64,')
  if (i === -1) return s
  return s.slice(i + 'base64,'.length)
}

export function normalizePngMaskBase64(input: string) {
  const s = String(input || '').trim()
  if (!s) return ''
  if (s.startsWith('data:')) return dataUrlToBase64(s)
  return s
}

